import { createIcon } from '@chakra-ui/react/icon'

const EditIcon = createIcon({
  displayName: 'EditIcon',
  viewBox: '0 0 12 12',
  path: [
    <path
      fill="currentColor"
      d="M9.523 3.7a.993.993 0 0 0 .293-.707.993.993 0 0 0-.293-.707l-.793-.793a.993.993 0 0 0-.707-.293.993.993 0 0 0-.707.293L2 6.793V9h2.207l5.316-5.3Zm-1.5-1.5.793.793-.795.792-.793-.793.795-.792ZM3 8v-.793l3.52-3.509.793.793L3.793 8H3Zm-1 2h8v1H2v-1Z"
    />,
  ],
})

export default EditIcon
